import React, {
  ComponentType,
  createElement,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { ActGridContainer, Container } from './styles';
import Separator from '~/components/Separator';
import { homeActions } from './utils/home-actions';
import { ButtonAction } from './Components/ButtonAction';
import { BtnUpdateAll } from './Components/BtnUpdateAll';
import { Card } from './Components/DashCard/Card';
import { DashButton } from './Components/DashCard/Button';
import { DashBody } from './Components/DashCard/Body/DashBody';
import { useDashboard } from './hooks/useDashboard';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { format } from 'date-fns';
import { homeLinks } from './utils/home-links';
import { nanoid } from 'nanoid';
import { ModalMoreAct } from './Components/ModalMoreAct';
import { BiPlus } from 'react-icons/bi';
import Joyride, { ACTIONS, EVENTS, STATUS, Step } from 'react-joyride';
import { formatTimeBR } from './utils/formatTimeBR';
import { NavbarContext } from '~/context/navbar';
import { Context } from '~/context/auth';
import api from '~/services/api';
import { getUserData } from '~/services/user';

const steps: Step[] = [
  {
    target: '.step-1',
    content:
      'Bem-vindo ao Konvix Gestão! 🚀 Vamos guiá-lo por um tour interativo para que você conheça as principais funcionalidades do sistema e aproveite ao máximo sua experiência. Clique em "Próximo" para começar!',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.step-1',
    content:
      'Inicie sua jornada com nossos materiais das rotinas básicas e acesse as principais ações  do sistema.',
    disableScrolling: true,
  },
  {
    target: '.section-dashboard',
    content:
      'No dashboard verá um raixo-X completo sobre o desempenho atual da sua empresa.',
    disableScrolling: true,
  },
  {
    target: '.sidebar',
    content: 'Familiarize-se com um menu repleto de opções.',
    disableScrolling: true,
    placement: 'right',
  },
  // // MENU
  // {
  //   target: '.left-menu-top',
  //   content:
  //     'Todas as telas podem ser acessadas por diversos modos de visualização para atender o seu modo de trabalho.',
  //   disableScrolling: true,
  //   placement: 'right',
  // },
  {
    target: '.modulos',
    content:
      'Para uma exploração mais direcionada, as telas estarão agrupadas em seus respectivos módulos.',
    disableScrolling: true,
    placement: 'right-start',
  },
  {
    target: '.search-input',
    content:
      'Pode também encontrar uma tela ou funcionalidade por digitar o que deseja na barra de pesquisa.',
    placement: 'bottom',
  },
  // // MENU
  {
    target: '#myTab',
    content:
      'À medida que for abrindo as telas, elas serão apresentadas na barra, e poderá alternar entre elas.',
    disableScrolling: true,
  },
  {
    target: '.zd-launcher-close__app',
    content:
      'A qualquer momento entre em contato conosco ou acesse nossa base de conhecimento por meio do comunicador.',
    disableScrolling: true,
  },
  {
    target: '.user-menu',
    content:
      'Detalhes sobre sua empresa, seu usuário e seu plano estão disponíveis no topo do menu.',
  },
  {
    target: '.step-1',
    content: (
      <div style={{ textAlign: 'center', position: 'relative' }}>
        <p style={{ fontSize: '20px' }}>
          Assista também esse breve tutorial e conheça o potencial do Konvix
          Gestão.
        </p>
        <a
          href="https://www.youtube.com/watch?v=_01NDwiDwWA&t=2s"
          target="_blank"
          rel="noopener noreferrer"
          style={{ position: 'relative', display: 'inline-block' }}
        >
          <img
            src="https://img.youtube.com/vi/_01NDwiDwWA/maxresdefault.jpg"
            alt="Tutorial Konvix Gestão"
            style={{
              width: '100%',
              maxWidth: '800px',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'block',
            }}
          />
          {/* Ícone de Play sobreposto */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              borderRadius: '50%',
              width: '80px',
              height: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg
              width="50"
              height="50"
              viewBox="0 0 24 24"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </a>
      </div>
    ),
    styles: {
      tooltip: {
        width: 800,
      },
    },
    placement: 'center',
  },
];

export const DashboardContent: React.FC<{ screen: any[] }> = ({ screen }) => {
  const { user, handleChangeUserData } = useContext(Context);
  const { setOpenMenu, setCloseMenuOnScroll } = useContext(NavbarContext);
  const { loading, handleUpdateDataDashboard, loadingQry } = useDashboard();
  const [openModalMoreAct, setOpenModalMoreAct] = useState(false);
  const [showPrimeirosPassos, setShowPrimeirosPassos] = useState(false);
  const [runJoyRide, setRunJoyRide] = useState(false);
  const [lastUpdatedTime, setLastUpdatedTime] = useState<string>(
    formatTimeBR(),
  );
  const { flg_admin } = getUserData();
  const isAdmin = Boolean(flg_admin);

  useEffect(() => {
    if (loading.ocorrencias || loadingQry) setLastUpdatedTime(formatTimeBR());
  }, [loading.ocorrencias, loadingQry]);

  const [stepIndex, setStepIndex] = useState(0);
  const handleJoyRideSteps = async (data: any) => {
    const { index, type, action, status } = data;

    if (index === 3 && type === 'step:before') {
      document.body.style.overflow = 'hidden';
    }
    if (index === 7 && type === 'step:before') {
      document.body.style.overflow = '';
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setOpenMenu(false);
      setCloseMenuOnScroll(true);
      setShowPrimeirosPassos(false);
      setStepIndex(0);
      document.body.style.overflow = '';
      if (user?.flg_primeiro_acesso) {
        await updateFlgPrimeiroAcesso();
        if (user)
          handleChangeUserData({
            ...user,
            flg_primeiro_acesso: false,
          });
      }

      return;
    }

    if (index === 2 && type === 'tooltip' && action === 'update') {
      const targetElement = document.querySelector('#myTab');
      targetElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (type === 'step:after' && index === 6 && action === 'next') {
      setCloseMenuOnScroll(false);
      setOpenMenu(false);
    }

    if (type === 'step:before' && index === 6 && action === 'prev') {
      setCloseMenuOnScroll(false);
      setOpenMenu(true);
    }

    if (type === 'step:before' && index === 3 && action === 'prev') {
      setCloseMenuOnScroll(true);
      setOpenMenu(false);
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if (type === 'error:target_not_found') {
        setTimeout(() => {
          setStepIndex(index);
        }, 500);
        return;
      }
      if (type === 'step:after' && index === 3 && action === 'next') {
        setCloseMenuOnScroll(false);
        setOpenMenu(true);
      }
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  };

  const onCloseModalMoreAct = useCallback(() => {
    setOpenModalMoreAct(false);
  }, []);

  useEffect(() => {
    handleUpdateDataDashboard('todos');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateFlgPrimeiroAcesso = async () => {
    await api.put('/primeiro-acesso/usuario', {
      flg_primeiro_acesso: false,
    });
  };

  const handleShowPrimeirosPassos = useCallback(() => {
    setOpenModalMoreAct(false);
    setShowPrimeirosPassos(true);
  }, [setOpenModalMoreAct, setShowPrimeirosPassos]);

  useEffect(() => {
    if (showPrimeirosPassos || user?.flg_primeiro_acesso) {
      setRunJoyRide(true);
    } else {
      setRunJoyRide(false);
    }
  }, [showPrimeirosPassos, user]);

  const visibleActions = homeActions.filter((action) => {
    if (!isAdmin && action.codTela === 2) return false;
    return true;
  });

  return (
    <Container>
      <div className="step-1">
        <section className="section-home-links">
          {homeLinks.map((link) => (
            <a
              key={nanoid()}
              href={link.link}
              className="container-links"
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.iconNode && (
                <div className="icon-container">
                  {createElement(link.iconNode as ComponentType)}
                </div>
              )}
              {link.label}
            </a>
          ))}
        </section>
        <section>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#bdbdbd' }}>Ações</span>
            <span
              style={{
                flexGrow: 1,
                borderBottom: '0.0625rem solid #ededed',
                margin: '0 0.625rem',
              }}
            />
            <button
              onClick={() => setOpenModalMoreAct(true)}
              style={{
                backgroundColor: 'transparent',
                borderColor: 'transparent',
              }}
              type="button"
              aria-label="button-open-modal"
            >
              <BiPlus size={23} color="#009e11" /> Mais ações
            </button>
          </div>
          <ActGridContainer>
            {visibleActions.map((action) => (
              <ButtonAction
                key={action.label}
                label={action.label}
                href={action.href}
                icon={action.icon}
                codTela={action.codTela}
                user={user}
                buttonDestaque={action.buttonDestaque}
                customBgColor={action.customBgColor || 'white'}
              />
            ))}
          </ActGridContainer>
        </section>
      </div>

      <section className="section-dashboard">
        <Separator labelText="Dashboard" marginTop="0" childrenWidth="auto">
          <BtnUpdateAll />
        </Separator>
        <div className="content-dashboard">
          <div className="left-side">
            <div className="cards-top-left">
              <Card
                title="A pagar"
                topRightButton={<DashButton tipo="add" url="/contas-a-pagar" />}
                body={<DashBody card="pagar" />}
                bgColor=" #DD4B39"
              />
              <Card
                title="A receber"
                topRightButton={
                  <DashButton tipo="add" url="/contas-a-receber" />
                }
                body={<DashBody card="receber" />}
                bgColor=" #00C0EF"
              />
              <Card
                title="Venda"
                topRightButton={<DashButton tipo="add" url="/pdv-online" />}
                body={<DashBody card="venda" />}
                bgColor="#00A65A"
              />
            </div>
            <div className="cards-bottom-left">
              <Card
                title="Venda"
                topChildren={
                  <DashButton tipo="requisito" tipoBusca="venda-grafico" />
                }
                body={<DashBody card="venda-grafico" />}
                bgColor="white"
              />
              <Card
                title="Caixas Hoje"
                topRightButton={
                  <DashButton
                    tipo="refresh"
                    tipoBusca="caixas-hoje"
                    isDisabled={loading.caixas_hoje || loadingQry}
                    svgColor="#009e11"
                  />
                }
                body={<DashBody card="caixas-hoje" />}
                bgColor="white"
              />
            </div>
          </div>
          <div className="right-side">
            <Card
              title="Ocorrências"
              topRightButton={
                <DashButton
                  tipo="refresh"
                  tipoBusca="ocorrencias"
                  isDisabled={loading.ocorrencias || loadingQry}
                />
              }
              topChildren={
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'white',
                  }}
                >
                  <FaRegCalendarAlt size={19} />
                  <span style={{ marginLeft: '0.3125rem' }}>
                    {format(new Date(), 'dd/MM/yyyy')} às {lastUpdatedTime}
                  </span>
                </div>
              }
              topChildrenMiddle={false}
              body={<DashBody card="ocorrencias" screen={screen} />}
              bgColor="#F39C12"
            />
            <Card
              title="Produtos"
              topRightButton={
                <DashButton tipo="add" url="/produto" svgColor="#009e11" />
              }
              body={<DashBody card="produtos" />}
              bgColor="white"
            />
          </div>
        </div>
      </section>
      <ModalMoreAct
        open={openModalMoreAct}
        onClose={onCloseModalMoreAct}
        showPrimeirosPassos={handleShowPrimeirosPassos}
      />
      <Joyride
        run={runJoyRide}
        steps={steps}
        continuous
        showSkipButton
        disableCloseOnEsc
        disableOverlayClose
        stepIndex={stepIndex}
        callback={handleJoyRideSteps}
        hideCloseButton
        showProgress
        locale={{
          back: 'Voltar',
          close: 'Fechar',
          last: 'Finalizar',
          next: 'Próximo',
          skip: 'Pular',
        }}
        styles={{
          options: {
            arrowColor: '#fff',
            backgroundColor: '#fff',
            overlayColor: 'rgba(0, 0, 0, 0.5)',
            primaryColor: '#57069e',
            spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
            textColor: '#333',
            width: undefined,
            zIndex: 999999999999999,
          },
        }}
      />
    </Container>
  );
};
